import { Theme } from '../../theme';

import { SwitchElementSize } from './types';

const getSwitchThemeVariant = (
  theme: Theme,
  elementSize: SwitchElementSize,
) => {
  if (elementSize === 'small') return theme.components.Switch.small;

  return theme.components.Switch.regular;
};

export default getSwitchThemeVariant;
